import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import api from '../lib/api';
import toast from 'react-hot-toast';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post('/api/auth/forgot-password', { email: email.trim() });
      setSubmitted(true);
    } catch (err) {
      toast.error(t('passwordReset.failed'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="forgot-password-page">
      <header className="px-8 py-6"><Logo/></header>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="so-card p-8 md:p-10 max-w-md w-full">
          <h1 className="text-2xl font-bold tracking-tight" data-testid="forgot-title">{t('passwordReset.title')}</h1>
          <p className="mt-2 text-sm text-text-secondary">{t('passwordReset.subtitle')}</p>
          {submitted ? (
            <div className="mt-6 rounded-md border border-success/30 bg-success/5 p-4 text-sm" data-testid="forgot-success">
              {t('passwordReset.success')}
              <div className="mt-4">
                <Link to="/login" className="so-btn so-btn-secondary text-xs" data-testid="back-to-login">
                  {t('passwordReset.backToLogin')}
                </Link>
              </div>
            </div>
          ) : (
            <form className="mt-6 space-y-4" onSubmit={handleSubmit} data-testid="forgot-form">
              <div>
                <label className="so-label">{t('passwordReset.emailLabel')}</label>
                <input
                  type="email"
                  className="so-input"
                  required
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email-input"
                />
              </div>
              <button
                type="submit"
                disabled={busy}
                className="so-btn so-btn-primary w-full"
                data-testid="forgot-submit-btn"
              >
                {busy ? t('passwordReset.sending') : t('passwordReset.sendLink')}
              </button>
              <div className="text-center">
                <Link to="/login" className="text-xs text-accent hover:underline" data-testid="back-to-login-link">{t('passwordReset.backToLogin')}</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
